export default "__VITE_ASSET__Dd$Y_Bdf__"